import { FeatureFlag } from './feature-flag-enums';
import { translationKeys } from '@locale/setupI18n';

/**
 * Maps feature flags to their localised display label. Flags without an entry here are
 * not shown in the feature flag UI, unless the server specifies them, in which case they
 * appear but with their numeric ID only.
 */
export const featureFlagLabels: Partial<Record<FeatureFlag, translationKeys>> = {
  [FeatureFlag.EraDevTools]: '_FeatureFlagDevTools',
  [FeatureFlag.DealThesisHistoricInputs]: '_FeatureFlagDealThesisHistoricInputs',
  [FeatureFlag.SignalrMonitor]: '_FeatureFlagsSignalrMonitor',
  [FeatureFlag.FeatureFlagModal]: '_FeatureFlagFfModal',
  [FeatureFlag.AiPackage]: '_AiPackage',
};
